/**
 * El código con el que el celular abre el almacén ya dentro (9 oct, docs/36
 * §2.7): `#/entrar?codigo=…`.
 *
 * El dueño de una bodega no va a teclear su correo y su contraseña en el
 * navegador del celular para ver sus lotes. El celular, que ya tiene sesión,
 * pide un código de un minuto y abre esta dirección; aquí se canjea por una
 * sesión propia. El código sirve una sola vez, y aun así se borra de la barra
 * y del historial **antes** de canjearlo: una dirección se queda en el
 * historial, y alguien que la vuelva a abrir no tiene por qué ver un código,
 * aunque ya no sirva.
 */
export function codigoDeLaUrl(hash: string): string | null {
  const [ruta, consulta] = hash.replace(/^#\/?/, '').split('?', 2);
  if (ruta !== 'entrar' || consulta === undefined) return null;

  const codigo = new URLSearchParams(consulta).get('codigo')?.trim() ?? '';
  // Lo que emite el servidor: 32 bytes en base64url. Otra cosa no se manda.
  return /^[A-Za-z0-9_-]{20,100}$/.test(codigo) ? codigo : null;
}

/** La dirección sin el código: la portada del almacén. */
export function direccionSinCodigo(ubicacion: { pathname: string; search: string }): string {
  return `${ubicacion.pathname}${ubicacion.search}#/resumen`;
}
